import { useState, useEffect, useRef } from "react";
import styles from "../HealthChat.module.css";
import { SCREEN } from "../HealthChatModal";
const DATA = {
  en: {
    welcome: "Welcome! I'm here to support you.",
    question:
      "I'll ask a few questions to better support you. Please select any symptoms you're experiencing:",
    continueBtn: "Continue",
    affirmation:
      "Many women experience these during hormonal changes. You're not alone.",
    symptomLabels: [
      "Hot flashes / Night sweats",
      "Irregular periods",
      "Mood swings / Anxiety",
      "Sleep issues",
      "Fatigue",
      "Weight changes",
      "Brain fog",
      "Joint pain",
      "Low libido",
      "Vaginal dryness",
    ],
    followUp: {
      "Hot flashes / Night sweats": {
        question: "How often are you experiencing hot flashes or night sweats?",
        options: [
          "Occasionally",
          "Daily",
          "Several times a day",
          "Severe / Affecting sleep",
        ],
      },
      "Irregular periods": {
        question: "How irregular are your periods?",
        options: [
          "Slightly irregular",
          "Skipping months",
          "Very unpredictable",
          "Stopped completely",
        ],
      },
      "Mood swings / Anxiety": {
        question: "How would you describe your mood changes?",
        options: [
          "Mild irritability",
          "Frequent mood swings",
          "Anxiety / Panic",
          "Depression symptoms",
        ],
      },
      "Sleep issues": {
        question: "What best describes your sleep problem?",
        options: [
          "Hard to fall asleep",
          "Waking up at night",
          "Early waking",
          "Unrefreshing sleep",
        ],
      },
      Fatigue: {
        question: "How does fatigue affect your daily life?",
        options: [
          "Mildly tired",
          "Often exhausted",
          "Affects daily tasks",
          "Severe / debilitating",
        ],
      },
      "Weight changes": {
        question: "What changes have you noticed with your weight?",
        options: [
          "Gradual gain",
          "Belly fat increase",
          "Sudden changes",
          "Hard to lose weight",
        ],
      },
      "Brain fog": {
        question: "How often are you experiencing brain fog?",
        options: [
          "Occasionally",
          "Daily",
          "Several times a day",
          "Severe / Affecting sleep",
        ],
      },
      "Joint pain": {
        question: "Where do you experience joint pain most?",
        options: [
          "Hands / Wrists",
          "Knees / Hips",
          "Whole body",
          "Morning stiffness",
        ],
      },
      "Low libido": {
        question: "How long have you noticed changes in libido?",
        options: ["Few weeks", "Few months", "Over a year", "Not sure"],
      },
      "Vaginal dryness": {
        question: "How does vaginal dryness affect you?",
        options: [
          "Mild discomfort",
          "Painful intercourse",
          "Daily discomfort",
          "Affects daily life",
        ],
      },
    },
  },

  hi: {
    welcome: "स्वागत है! मैं यहाँ आपकी सहायता के लिए हूँ।",
    question:
      "आपकी बेहतर सहायता के लिए मैं कुछ प्रश्न पूछूंगा। कृपया अपने लक्षण चुनें:",
    continueBtn: "जारी रखें",
    affirmation:
      "कई महिलाएं हार्मोनल बदलावों के दौरान इन्हें अनुभव करती हैं। आप अकेली नहीं हैं।",
    symptomLabels: [
      "गर्म लहरें / रात को पसीना",
      "अनियमित माहवारी",
      "मूड बदलाव / चिंता",
      "नींद की समस्याएं",
      "थकान",
      "वजन में बदलाव",
      "ब्रेन फॉग",
      "जोड़ों का दर्द",
      "कामेच्छा में कमी",
      "योनि में सूखापन",
    ],
    followUp: {
      "गर्म लहरें / रात को पसीना": {
        question: "आप कितनी बार गर्म लहरें या रात को पसीना अनुभव करती हैं?",
        options: ["कभी-कभी", "रोज़", "दिन में कई बार", "गंभीर / नींद प्रभावित"],
      },
      "अनियमित माहवारी": {
        question: "आपकी माहवारी कितनी अनियमित है?",
        options: [
          "थोड़ी अनियमित",
          "महीने छोड़ रही है",
          "बहुत अनिश्चित",
          "पूरी तरह बंद",
        ],
      },
      "मूड बदलाव / चिंता": {
        question: "आपके मूड बदलावों का वर्णन कैसे करेंगी?",
        options: [
          "हल्की चिड़चिड़ाहट",
          "बार-बार मूड बदलाव",
          "चिंता / घबराहट",
          "अवसाद के लक्षण",
        ],
      },
      "नींद की समस्याएं": {
        question: "आपकी नींद की समस्या क्या है?",
        options: [
          "सोने में परेशानी",
          "रात में जागना",
          "जल्दी जागना",
          "अपर्याप्त नींद",
        ],
      },
      थकान: {
        question: "थकान आपके दैनिक जीवन को कैसे प्रभावित करती है?",
        options: ["हल्की थकान", "अक्सर थकावट", "दैनिक कार्यों पर असर", "गंभीर"],
      },
      "वजन में बदलाव": {
        question: "वजन में क्या बदलाव देखा है?",
        options: [
          "धीरे-धीरे बढ़ रहा है",
          "पेट की चर्बी",
          "अचानक बदलाव",
          "वजन कम नहीं होता",
        ],
      },
      "ब्रेन फॉग": {
        question: "ब्रेन फॉग कितनी बार होता है?",
        options: ["कभी-कभी", "रोज़", "दिन में कई बार", "गंभीर"],
      },
      "जोड़ों का दर्द": {
        question: "कहाँ दर्द होता है?",
        options: ["हाथ / कलाई", "घुटने / कूल्हे", "पूरा शरीर", "सुबह की जकड़न"],
      },
      "कामेच्छा में कमी": {
        question: "कब से यह बदलाव महसूस हो रहा है?",
        options: ["कुछ हफ्ते", "कुछ महीने", "एक साल से ज्यादा", "पता नहीं"],
      },
      "योनि में सूखापन": {
        question: "यह कैसे प्रभावित करता है?",
        options: [
          "हल्की तकलीफ",
          "दर्दनाक संबंध",
          "रोज़ की तकलीफ",
          "जीवन प्रभावित",
        ],
      },
    },
  },

  te: {
    welcome: "స్వాగతం! నేను మీకు సహాయం చేయడానికి ఇక్కడ ఉన్నాను.",
    question:
      "మీకు మెరుగైన సహాయం చేయడానికి కొన్ని ప్రశ్నలు అడుగుతాను. దయచేసి మీ లక్షణాలను ఎంచుకోండి:",
    continueBtn: "కొనసాగించు",
    affirmation:
      "చాలా మంది మహిళలు హార్మోనల్ మార్పుల సమయంలో ఇవి అనుభవిస్తారు. మీరు ఒంటరిగా లేరు.",
    symptomLabels: [
      "హాట్ ఫ్లాషెస్ / రాత్రి చెమటలు",
      "అనియమిత పీరియడ్స్",
      "మూడ్ మార్పులు / ఆందోళన",
      "నిద్ర సమస్యలు",
      "అలసట",
      "బరువు మార్పులు",
      "బ్రెయిన్ ఫాగ్",
      "కీళ్ళ నొప్పి",
      "తక్కువ కామవాంఛ",
      "యోని పొడిబారడం",
    ],
    followUp: {
      "హాట్ ఫ్లాషెస్ / రాత్రి చెమటలు": {
        question:
          "మీరు హాట్ ఫ్లాషెస్ లేదా రాత్రి చెమటలు ఎంత తరచుగా అనుభవిస్తున్నారు?",
        options: [
          "అప్పుడప్పుడు",
          "రోజూ",
          "రోజుకు చాలాసార్లు",
          "తీవ్రంగా / నిద్రను ప్రభావితం",
        ],
      },
      "అనియమిత పీరియడ్స్": {
        question: "మీ పీరియడ్స్ ఎంత అనియమితంగా ఉన్నాయి?",
        options: [
          "కొంచెం అనియమితం",
          "నెలలు దాటుతున్నాయి",
          "చాలా అనిశ్చితం",
          "పూర్తిగా ఆగిపోయాయి",
        ],
      },
      "మూడ్ మార్పులు / ఆందోళన": {
        question: "మీ మూడ్ మార్పులు ఎలా ఉంటున్నాయి?",
        options: [
          "తేలికపాటి చిరాకు",
          "తరచుగా మూడ్ మార్పులు",
          "ఆందోళన / భయం",
          "నిరాశ లక్షణాలు",
        ],
      },
      "నిద్ర సమస్యలు": {
        question: "మీ నిద్ర సమస్య ఏమిటి?",
        options: [
          "నిద్రపోవడం కష్టం",
          "రాత్రి మేల్కొనడం",
          "పెందలాడే మేల్కొనడం",
          "అసంతృప్తికర నిద్ర",
        ],
      },
      అలసట: {
        question: "అలసట మీ దైనందిన జీవితాన్ని ఎలా ప్రభావితం చేస్తోంది?",
        options: [
          "తేలికపాటి అలసట",
          "తరచుగా అలసట",
          "రోజువారీ పనులపై ప్రభావం",
          "తీవ్రమైన అలసట",
        ],
      },
      "బరువు మార్పులు": {
        question: "బరువులో ఏ మార్పులు గమనించారు?",
        options: [
          "క్రమంగా పెరుగుదల",
          "పొట్ట కొవ్వు పెరుగుదల",
          "అకస్మాత్తు మార్పులు",
          "బరువు తగ్గడం కష్టం",
        ],
      },
      "బ్రెయిన్ ఫాగ్": {
        question: "మీరు బ్రెయిన్ ఫాగ్ ఎంత తరచుగా అనుభవిస్తున్నారు?",
        options: ["అప్పుడప్పుడు", "రోజూ", "రోజుకు చాలాసార్లు", "తీవ్రంగా"],
      },
      "కీళ్ళ నొప్పి": {
        question: "మీకు ఎక్కడ నొప్పి ఎక్కువగా ఉంటోంది?",
        options: [
          "చేతులు / మణికట్టు",
          "మోకాళ్ళు / తుంటి",
          "మొత్తం శరీరం",
          "ఉదయం బిగువు",
        ],
      },
      "తక్కువ కామవాంఛ": {
        question: "ఎంత కాలం నుండి ఈ మార్పులు గమనిస్తున్నారు?",
        options: [
          "కొన్ని వారాలు",
          "కొన్ని నెలలు",
          "ఒక సంవత్సరం పైగా",
          "తెలియదు",
        ],
      },
      "యోని పొడిబారడం": {
        question: "ఇది మీకు ఎలా ప్రభావితం చేస్తోంది?",
        options: [
          "తేలికపాటి అసౌకర్యం",
          "నొప్పిగా ఉంది",
          "రోజూ అసౌకర్యం",
          "జీవితాన్ని ప్రభావితం చేస్తోంది",
        ],
      },
    },
  },
};

const PHASE = { SELECT: "select", FOLLOWUP: "followup" };

export default function SymptomChatScreen({ lang = "en", onComplete, onBack }) {
  const d = DATA[lang] || DATA.en;

  const [phase, setPhase] = useState(PHASE.SELECT);
  const [selected, setSelected] = useState([]);
  const [screen, setScreen] = useState(SCREEN.WELCOME);
  const go = (s) => setScreen(s);
  // Controls visibility of chips + button (hidden after Continue)
  const [chipsVisible, setChipsVisible] = useState(true);

  // Animation states — welcome/question always stay; chips animate in after question appears
  const [showWelcome, setShowWelcome] = useState(false);
  const [showQuestion, setShowQuestion] = useState(false);
  const [showChips, setShowChips] = useState(false);

  const [messages, setMessages] = useState([]);
  const [currentIdx, setCurrentIdx] = useState(0);
  const [answers, setAnswers] = useState({});

  const bottomRef = useRef(null);

  // Staggered entrance: welcome → question → chips + button
  useEffect(() => {
    const t1 = setTimeout(() => setShowWelcome(true), 200);
    const t2 = setTimeout(() => setShowQuestion(true), 900);
    const t3 = setTimeout(() => setShowChips(true), 1500);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, phase]);

  function toggleSymptom(label) {
    setSelected((prev) =>
      prev.includes(label) ? prev.filter((s) => s !== label) : [...prev, label],
    );
  }

  function handleContinue() {
    // Hide chips & button immediately on Continue click
    setChipsVisible(false);

    if (selected.length === 0) {
      onComplete({ selectedSymptoms: [], answers: {} });
      return;
    }
    const firstSymptom = selected[0];
    const firstQ = d.followUp[firstSymptom];

    const initMsgs = [
      { type: "user", text: selected.join(", ") },
      { type: "bot", text: d.affirmation },
    ];

    if (firstQ) {
      initMsgs.push({
        type: "bot",
        text: firstQ.question,
        options: firstQ.options,
        symptom: firstSymptom,
      });
    }

    setMessages(initMsgs);
    setCurrentIdx(0);
    setPhase(PHASE.FOLLOWUP);
  }

  function handleAnswer(symptom, answer) {
    const newAnswers = { ...answers, [symptom]: answer };
    setAnswers(newAnswers);

    const userMsg = { type: "user", text: answer };
    const nextIdx = currentIdx + 1;
    const nextSymptom = selected[nextIdx];

    if (nextSymptom) {
      const nextQ = d.followUp[nextSymptom];
      const nextMsgs = nextQ
        ? [
            {
              type: "bot",
              text: nextQ.question,
              options: nextQ.options,
              symptom: nextSymptom,
            },
          ]
        : [];
      setMessages((prev) => [...prev, userMsg, ...nextMsgs]);
      setCurrentIdx(nextIdx);
    } else {
      setMessages((prev) => [...prev, userMsg]);
      setTimeout(
        () => onComplete({ selectedSymptoms: selected, answers: newAnswers }),
        400,
      );
    }
  }
  //const go = (s) => setScreen(s);
  const activeSymptom = selected[currentIdx];

  return (
    <div
      className={
        phase === PHASE.SELECT ? styles.symptomScreen : styles.followUpScreen
      }
    >
      <button className={styles.selectDoctorBack} onClick={onBack}>
        ← Back
      </button>
      {/* ── SELECT phase ── */}
      {/* {phase === PHASE.SELECT && ( */}
      <>
        {/* Welcome bubble — always visible, fades in on mount */}
        <div
          className={`${styles.botBubble} ${styles.CBbodyText} ${showWelcome ? styles.bubbleVisible : styles.bubbleHidden}`}
        >
          {d.welcome}
        </div>

        {/* Question bubble — always visible, fades in after welcome */}
        <div
          className={`${styles.botBubble} ${styles.CBbodyText} ${showQuestion ? styles.bubbleVisible : styles.bubbleHidden}`}
        >
          {d.question}
        </div>

        {/* Chips + button — animate in, then hide after Continue */}
        {chipsVisible && (
          <>
            <div
              className={`${styles.symptomChips} ${showChips ? styles.bubbleVisible : styles.bubbleHidden}`}
            >
              {d.symptomLabels.map((label, i) => (
                <button
                  key={i}
                  style={{ transitionDelay: showChips ? `${i * 40}ms` : "0ms" }}
                  className={`${styles.CBbodyText} ${selected.includes(label) ? styles.chipActive : styles.chip} ${showChips ? styles.chipItemVisible : styles.chipItemHidden}`}
                  onClick={() => toggleSymptom(label)}
                >
                  {label}
                </button>
              ))}
            </div>

            <div
              className={showChips ? styles.bubbleVisible : styles.bubbleHidden}
              style={{
                transitionDelay: showChips
                  ? `${d.symptomLabels.length * 40 + 60}ms`
                  : "0ms",
              }}
            >
              <button className={styles.continueBtn} onClick={handleContinue}>
                {d.continueBtn} →
              </button>
            </div>
          </>
        )}
      </>
      {/* )} */}

      {/* ── FOLLOWUP phase ── */}
      {/* {phase === PHASE.FOLLOWUP && ( */}
      <>
        {messages.map((msg, i) => {
          if (msg.type === "user") {
            return (
              <div key={i} className={styles.userBubbleRight}>
                {msg.text}
              </div>
            );
          }

          const isAnswered = msg.symptom && answers[msg.symptom];
          const isActive =
            msg.options && msg.symptom === activeSymptom && !isAnswered;

          return (
            <div key={i}>
              <div className={styles.botBubbleFollowUp}>{msg.text}</div>
              {/* Only show chips for the active unanswered question */}
              {msg.options && !isAnswered && (
                <div className={styles.followUpBtnGroup}>
                  {msg.options.map((opt) => (
                    <button
                      key={opt}
                      className={
                        isActive
                          ? styles.followUpChip
                          : styles.followUpChipDisabled
                      }
                      onClick={() => isActive && handleAnswer(msg.symptom, opt)}
                      disabled={!isActive}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
        <div ref={bottomRef} />
      </>
      {/* )} */}
    </div>
  );
}
